export enum AuthActionsType {
  LOGIN_GOOGLE = "LOGIN_GOOGLE",
  LOGIN_GOOGLE_SUCCESS = "LOGIN_GOOGLE_SUCCESS",
  LOGIN_GOOGLE_ERROR = "LOGIN_GOOGLE_ERROR",

  LOGOUT_GOOGLE = "LOGOUT_GOOGLE",
  LOGOUT_GOOGLE_SUCCESS = "LOGOUT_GOOGLE_SUCCESS",
  LOGOUT_GOOGLE_ERROR = "LOGOUT_GOOGLE_ERROR",

  SET_USER = "SET_USER",
  SET_USER_SUCCESS = "SET_USER_SUCCESS",
  SET_USER_ERROR = "SET_USER_ERROR",

  LOAD_STORAGE_DATA = "LOAD_STORAGE_DATA",
  LOAD_STORAGE_DATA_SUCCESS = "LOAD_STORAGE_DATA_SUCCESS",
  LOAD_STORAGE_DATA_ERROR = "LOAD_STORAGE_DATA_ERROR",
}
